import chatBubble from "./chatBubble.png"
import background from "./background.png"
import diamond0 from "./diamond0.png"
import diamond1 from "./diamond1.png"
import diamond2 from "./diamond2.png"
import diamond3 from "./diamond3.png"
import diamond4 from "./diamond4.png"

const customTestimonialsComponentsAssets = {
    chatBubble,
    background,
    diamond0,
    diamond1,
    diamond2,
    diamond3,
    diamond4
}

export default customTestimonialsComponentsAssets